const route = {
    path: "/home",
    name: "Home",
    component: () => import( /*webpackChunkName: "home"*/ "./view/Home.vue"),
    meta: {
        title: "首页",
        layout: 'PageLayout',
        isRequiredAuth: false,
        isRequiredEnterpriseAuth: false,
        isHome: true
    }
}

export default route